export default "__VITE_ASSET__BtI1x3c9__"